import React from 'react';
import { Tooltip, Form, List, Card, Tabs, Menu, Select, Input, Layout, Row, Col, Icon, Button, Tree, Avatar } from 'antd';
import styled, { keyframes } from 'styled-components';
import Header from './Header';
import Skeleton from './Skeleton';
import Divider from './Divider';

const SLIDE_IN = keyframes`
  from {
    left: 100%;
  }

  to {
    left: 0;
  }
`;

const FADE_IN = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const PanelRoute = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  overflow: hidden;
  position: relative;
  background: rgb(17, 44, 68);
`;

const PanelBodyContainer = styled.div`
  overflow: auto;
  flex: 1;
`;

const PanelSubPanelContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 100%;
  z-index: 2;
  animation: ${SLIDE_IN} 300ms cubic-bezier(0.86, 0, 0.07, 1) forwards;
`;

const PanelHeaderCover = styled.div`
  position: absolute;
  width: 100%;
  top: 0;
  z-index: 1;
  /*
    opacity: 0;
    animation: ${FADE_IN} 300ms linear forwards;
  */
`;

const Index = ({
  loading,
  onFilter,
  onCancel,
  filterTerm,
  subRoute,
  onBack,
  title,
  subTitle,
  actions,
  children,
  footer
}) => (
  <PanelRoute>
    {subRoute && <PanelSubPanelContainer>{subRoute}</PanelSubPanelContainer>}
    <div>
      <Header
        actions={actions}
        onBack={onBack}
        loading={loading}
        onCancel={onCancel}
      >
        {!onFilter
          ? (
            <Header.Title
              title={title}
              subTitle={subTitle}
            />
          ) : (
            <Header.Filter
              value={filterTerm}
              onFilter={onFilter}
            />
          )
        }
      </Header>
      {/*{headerCover && <PanelHeaderCover>{headerCover}</PanelHeaderCover>}*/}
    </div>
    <PanelBodyContainer>
      {children}
    </PanelBodyContainer>
    {footer && (
      <div style={{ padding: '8px', borderTop: '1px rgba(255, 255, 255, 0.1) solid' }}>
        {footer}
      </div>
    )}
  </PanelRoute>
);


Index.Header = Header;
Index.Skeleton = Skeleton;
Index.Divider = Divider;

export default Index;
